'use client'

interface CompanyBannerProps {
  bannerUrl: string | null
  companyName: string
}

export function CompanyBanner({ bannerUrl, companyName }: CompanyBannerProps) {
  if (bannerUrl) {
    return (
      <div className="relative mb-6 h-[150px] w-full overflow-hidden rounded-xl sm:h-[200px]">
        <img
          src={bannerUrl}
          alt={`${companyName} banner`}
          className="h-full w-full object-cover"
        />
        {/* Bottom gradient overlay for readability */}
        <div
          className="absolute inset-x-0 bottom-0 h-1/3"
          style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.3), transparent)' }}
        />
      </div>
    )
  }

  // Fallback: soft gradient with subtle grid pattern
  return (
    <div className="relative mb-6 h-[150px] w-full overflow-hidden rounded-xl sm:h-[200px]">
      <div className="absolute inset-0 bg-gradient-to-br from-[var(--color-brand-indigo)]/40 via-[var(--color-brand-violet)]/30 to-[var(--color-brand-indigo)]/20 dark:from-[var(--color-brand-indigo)]/30 dark:via-[var(--color-brand-violet)]/20 dark:to-[var(--color-bg-page)]" />
      <div
        className="absolute inset-0 opacity-[0.12] dark:opacity-[0.06]"
        style={{
          backgroundImage:
            'radial-gradient(circle, var(--color-brand-indigo) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />
    </div>
  )
}
